module.exports = __webpack_public_path__ + "img/pea-logo.15e27f4f.png";